/**
 *
 * @param {string} url
 * @param {"_blank"|"_self"} target - set to "_self" to stay on same tab
 */
const externalNavigate = (url, target = "_blank") => {
  window.open(url, target);
};

export default externalNavigate;
